(() => {
  const rail = document.querySelector('[data-gnr]');
  const catalog = document.querySelector('giesto-store-collection, giesto-collection-hub');
  if (!rail) return;

  const controls = [...rail.querySelectorAll('[data-gnr-layout]')];
  const track = rail.querySelector('.gnr__track');
  const centerShortCategories = () => {
    const links = [...track.querySelectorAll('a')];
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const contentWidth = links.reduce((width, link) => width + link.getBoundingClientRect().width, 0) + Math.max(0, links.length - 1) * gap;
    const rect = rail.getBoundingClientRect();
    const view = rail.querySelector('.gnr__view:not([hidden])');
    const inset = view ? view.getBoundingClientRect().right - rect.left + 16 : parseFloat(getComputedStyle(rail).paddingLeft);
    rail.classList.toggle('gnr--centered', contentWidth <= rect.width - 2 * inset);
  };
  window.addEventListener('resize', centerShortCategories, { passive: true });
  document.fonts.ready.then(centerShortCategories);
  centerShortCategories();
  const basicTypeTracks = [...document.querySelectorAll('[data-basic-type-track]')];
  const isBasicCategory = rail.dataset.profile?.startsWith('basic-category-v3-');
  const fitFromHash = () => location.hash.match(/^#fit-([a-z0-9-]+)$/i)?.[1]?.toLowerCase() || '';
  const primeBasicTypeTracks = () => {
    basicTypeTracks.forEach(typeTrack => {
      if (typeTrack.dataset.basicPeekPrimed === 'true') return;
      const firstCard = typeTrack.querySelector('.gbs__type');
      const cardWidth = firstCard?.getBoundingClientRect().width || 0;
      if (!cardWidth) return;
      typeTrack.scrollLeft = 0;
      typeTrack.dataset.basicPeekPrimed = 'true';
    });
  };

  const serverCurrent = track.querySelector('[aria-current="page"]');
  const syncHashCurrent = () => {
    const hash = location.hash;
    const fit = fitFromHash();
    const links = [...track.querySelectorAll('a[href]')];
    const selected = links.find(link => {
      const url = new URL(link.href, location.href);
      if (hash && url.hash === hash) return true;
      return fit && link.dataset.gnrTag === fit;
    });
    links.forEach(link => link.removeAttribute('aria-current'));
    (selected || serverCurrent)?.setAttribute('aria-current', 'page');
  };
  syncHashCurrent();
  window.addEventListener('hashchange', syncHashCurrent);
  window.addEventListener('popstate', syncHashCurrent);
  const storageKey = catalog
    ? catalog.matches('giesto-collection-hub')
      ? `giesto-hub-layout:${rail.dataset.profile || rail.dataset.mode}`
      : `giesto:catalog-layout:${rail.dataset.profile || rail.dataset.mode}`
    : null;
  const setLayout = layout => {
    if (catalog?.hasAttribute('data-gac-grid-only')) layout = 'uniform';
    if (!catalog || (layout !== 'editorial' && layout !== 'uniform' && layout !== 'showcase')) return;
    if (catalog.matches('giesto-collection-hub')) {
      if (catalog.setLayout) catalog.setLayout(layout, false);
      else catalog.dataset.layout = layout;
    }
    else {
      catalog.dataset.gnrLayout = layout;
      if (layout !== 'showcase') {
        const nativeValue = layout === 'editorial' ? 'stories' : '4';
        const nativeControl = catalog.querySelector(`[data-gac-view-option][value="${nativeValue}"]`);
        if (nativeControl && catalog.dataset.gacView !== nativeValue) {
          nativeControl.checked = true;
          nativeControl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    controls.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.gnrLayout === layout)));
    if (storageKey) try { sessionStorage.setItem(storageKey, layout); } catch {}
    if (layout === 'showcase') requestAnimationFrame(primeBasicTypeTracks);
  };

  let pendingFitScroll = 'auto';
  let activeFit = fitFromHash();
  const showFit = (behavior = 'auto') => {
    const fit = fitFromHash();
    if (!fit || !catalog?.matches('giesto-store-collection')) return;
    activeFit = fit;
    pendingFitScroll = behavior;
    setLayout('editorial');
    customElements.whenDefined('giesto-collection-stories').then(() => {
      catalog.querySelector('giesto-collection-stories')?.activate?.();
    });
  };

  document.addEventListener('giesto:stories-ready', event => {
    const fit = fitFromHash();
    if (!fit || event.detail?.fit !== fit) return;
    requestAnimationFrame(() => {
      document.getElementById(`fit-${fit}`)?.scrollIntoView({ behavior: pendingFitScroll, block: 'start' });
      pendingFitScroll = 'auto';
    });
  });

  rail.addEventListener('click', event => {
    const control = event.target.closest('[data-gnr-layout]');
    if (control) {
      if (control.dataset.gnrLayout === 'showcase' && fitFromHash()) {
        history.replaceState(history.state, '', `${location.pathname}${location.search}`);
        activeFit = '';
      }
      setLayout(control.dataset.gnrLayout);
    }
  });

  basicTypeTracks.forEach(typeTrack => typeTrack.addEventListener('click', event => {
    const link = event.target.closest('[data-basic-fit-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.href);
    if (!catalog?.matches('giesto-store-collection') || destination.pathname !== location.pathname || destination.search !== location.search) return;
    event.preventDefault();
    history.pushState({ ...(history.state || {}), giestoFit: link.dataset.basicFitLink }, '', link.hash);
    syncHashCurrent();
    showFit('smooth');
  }));

  // Touch devices get native momentum scrolling from overflow-x. Add the same
  // direct-manipulation affordance for a mouse without turning category links
  // into accidental clicks at the end of a drag.
  const makeMouseDraggable = track => {
    if (!track) return;
    let drag = null;
    let suppressClick = false;

    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || track.scrollWidth <= track.clientWidth) return;
      drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft, moved: false };
    });

    track.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) > 4) {
        drag.moved = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      }
      if (drag.moved) track.scrollLeft = drag.left - distance;
    });

    const endDrag = event => {
      if (!drag || event.pointerId !== drag.id) return;
      suppressClick = drag.moved;
      drag = null;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      window.setTimeout(() => { suppressClick = false; }, 0);
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', event => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  };

  makeMouseDraggable(track);
  if (!catalog) return;
  [...basicTypeTracks, ...document.querySelectorAll('.gch-story__products')].forEach(makeMouseDraggable);

  let saved;
  try { saved = sessionStorage.getItem(storageKey); } catch {}
  const availableLayouts = () => controls.map(control => control.dataset.gnrLayout);
  const requestedProducts = new URL(location.href).searchParams.get('giesto_view') === 'products';
  const initialLayout = fitFromHash() && availableLayouts().includes('editorial')
    ? 'editorial'
    : requestedProducts && availableLayouts().includes('editorial')
    ? 'editorial'
    : availableLayouts().includes(saved) ? saved : rail.dataset.defaultLayout;
  setLayout(initialLayout);
  if (fitFromHash()) showFit('auto');
  const restoreFitState = () => {
    if (fitFromHash()) showFit('auto');
    else if (isBasicCategory) {
      activeFit = '';
      setLayout('editorial');
    }
  };
  window.addEventListener('hashchange', restoreFitState);
  window.addEventListener('popstate', restoreFitState);
  if (catalog.matches('giesto-store-collection, giesto-collection-hub')) {
    customElements.whenDefined(catalog.localName).then(() => setLayout(initialLayout));
  }
})();
